<template>
  <div id="materialDetails" v-loading="isLoadingImg">
    <header-top  showBack></header-top>
    <div class="header-title show-back">上传{{headerText}}</div>
    <div class="material-tip">
      <svg-icon icon-class="icon-tips" class="icon-tips" />
      <ul>
        <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips"/>
        <li class="tips-tit">
          小贴士
          <i
            class="el-icon-caret-top tips-btn"
            v-if="showTips"
            @click="showTip"
          ></i>
          <i class="el-icon-caret-bottom tips-btn" v-else @click="showTip"></i>
        </li>
        <li v-if="showTips">
          <span></span>
          <div
            v-if="
              headerText == '身份证原件照片' ||
              headerText == '学历证明' ||
              headerText == '个人证件照'
            "
          >
            {{ headerText }}必须为员工本人{{ headerText }}，不能上传其他人{{ headerText }}进行代替
          </div>
          <div v-else>
            {{ headerText }}可为pdf、word等格式文件
          </div>
        </li>
        <li v-if="showTips">
          <span></span>
          <div>
            上传{{ headerText }}图片格式建议为JPG或PNG格式；照片文字清晰可见；大小不超过5M
          </div>
        </li>
      </ul>
    </div>

    <div class="main">
      <div class="tit">请上传{{ headerText }}资料</div>
      <!-- <div class="update-box">
        <div class="material-info">
          <div class="material-details">
            <div v-for="(item,index) in fileList" :key="index" class="img-list">
              <div class="img-box">
                <el-image :src="item.url"></el-image>
                <el-image-viewer
                  v-if="showViewer==index"
                  :on-close="()=>{showViewer=-1}"
                  :url-list="[item.url]"
                />
                <div class="img-info">
                  <div class="img-name">{{item.fileName}}</div>
                  <div class="img-size">文件大小：{{item.length|changeSize}}</div>
                  <div class="img-btn">
                    <div class="btn">重新上传</div>
                    <div class="btn" @click="showViewer=index">预览</div>
                    <div class="btn" @click="deltetOpen(item)">删除</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="img-list">
              <el-upload
                action="#"
                drag
                list-type="picture-card"
                :show-file-list="false"
                :auto-upload="true"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uplaodMaterialsInfo"
              >
                <div class="upload-tips">
                  <span>点击上传</span>/拖拽到此区域
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div> -->

      <idCard-material
        v-if="headerText == '身份证原件照片'"
        :isLoadingImg="isLoadingImg"
        @isLoading="loadingImg"
      ></idCard-material>
      <education-material
        v-else-if="headerText == '学历证明'"
        :isLoadingImg="isLoadingImg"
        @isLoading="loadingImg"
      ></education-material>
      <credentials-material
        v-else-if="headerText == '个人证件照'"
        :isLoadingImg="isLoadingImg"
        @isLoading="loadingImg"
      ></credentials-material>
      <material-currencyInfo
        v-else
        :isLoadingImg="isLoadingImg"
        @isLoading="loadingImg"
      ></material-currencyInfo>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import materialCurrencyInfo from "./material/material-currency-info";
import idCardMaterial from "./material/material-idCard";
import educationMaterial from "./material/material-education";
import credentialsMaterial from "./material/material-credentials";

import {
  getMaterials,
  uploadMaterials,
  deleteMaterials,
} from "@/http/api/employe";
export default {
  name: "Index",
  components: {
    headerTop,
    materialCurrencyInfo,
    idCardMaterial,
    educationMaterial,
    credentialsMaterial,
  },
  data() {
    return {
      headerText: this.$route.query.type,
      id: this.$route.params.id,
      fileList: [],
      showViewer: -1,
      isLoadingImg: true,
      showTips: true,
    };
  },
  mounted() {
    // this.getMaterialList();
  },
  methods: {
    showTip() {
      this.showTips = !this.showTips;
    },
    loadingImg(val) {
      this.isLoadingImg = val;
    },
    // deltetOpen(file) {
    //   // if (this.user.coupon_delete) {
    //   //console.log(file, "获取的file");
    //   this.$confirm(`你确定要删除吗?`, "温馨提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.deltetMaterial(file);
    //       //console.log(1111111111111);
    //     })
    //     .catch(() => {
    //       //console.log("取消删除");
    //     });
    //   // } else {
    //   //   this.$alert("权限不足!", "温馨提示", {
    //   //     confirmButtonText: "确定"
    //   //   });
    //   // }
    // },
    // deltetMaterial(val) {
    //   //console.log(val, "获取的删除信息");
    //   let data = {
    //     type: this.headerText,
    //     materialIds: [val.id],
    //   };
    //   deleteMaterials(this.id, data).then((res) => {
    //     //console.log(res, "删除后");
    //     this.getMaterialList();
    //   });
    // },
    // getMaterialList() {
    //   let query = {
    //     type: this.headerText,
    //   };
    //   getMaterials(this.id, query).then((res) => {
    //     //console.log(res, "获取的res");
    //     this.fileList = res.result.items;
    //   });
    // },
    // uplaodMaterialsInfo(req) {
    //   //console.log(req, "获取的文件数据");
    //   const file = req.file;
    //   var formData = new FormData();
    //   formData.append("Type", this.headerText);
    //   formData.append("Files", file);
    //   //console.log(uploadMaterials(this.id, formData), "获取的接口");
    //   uploadMaterials(this.id, formData).then((res) => {
    //     this.$message({
    //       message: "用户信息更新成功！",
    //       type: "success",
    //     });
    //     this.getMaterialList();
    //   });
    // },
    // beforeAvatarUpload(file) {
    //   //console.log(file, "获取的file");
    //   const isPIC = file.type === "image/jpeg" || file.type === "image/png";
    //   const isLt5M = file.size / 1024 / 1024 < 5;

    //   if (!isPIC) {
    //     this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
    //   }
    //   if (!isLt5M) {
    //     this.$message.error("上传头像图片大小不能超过 5MB!");
    //   }
    //   return isPIC && isLt5M;
    // },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.material-tip {
  @include flex(row, flex-start);
  margin: 20px 20px 0;
  padding: 20px;
  font-size: 12px;
  font-weight: 500;
  background: #fff;
  .icon-tips {
    color: $--color-primary;
    padding: 10px 0;
  }
  ul {
    margin: 0;
    position: relative;
    padding-left: 10px;
    width: 100%;
    .icon-tips-bg {
      position: absolute;
      right: 0px;
      bottom: -94px;
      font-size: 250px;
    }
    li {
      @include flex(row, center);
      margin-bottom: 10px;
      width: 100%;
      span {
        display: inline-block;
        margin-right: 5px;
        border-radius: 50%;
        padding: 2px;
        background: #111;
      }
    }
    .tips-tit {
      justify-content: space-between;
      .tips-btn {
        position: relative;
        z-index: 99;
        padding: 10px;
        cursor: pointer;
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
.main {
  margin: 20px;
  padding: 26px 19px;
  border-radius: $--border-radius-base;
  min-height: calc(100vh - 240px);
  // box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  .tit {
    margin-bottom: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }

  .update-box {
    @include flex(row, center);
    flex-wrap: wrap;
    .material-info {
      margin-bottom: 20px;
      .card-tit {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666666;
      }
      .material-details {
        @include flex(row, center);
        flex-wrap: wrap;
        justify-content: flex-start;
        .img-list {
          margin-bottom: 30px;
          width: 390px;
          .img-box {
            @include flex(row, flex-end);

            .el-image {
              width: 200px;
              height: 148px;
              text-align: center;
              display: flex;
              align-items: center;
              box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
              ::v-deep .el-image__inner {
                width: 200px;
                height: auto;
              }
            }
            ::v-deep .el-image-viewer__close {
              color: #fff;
            }
            .img-info {
              margin-left: 10px;
              margin-bottom: 20px;
              .img-name {
                margin-bottom: 10px;
              }
              .img-btn {
                @include flex(row, center);
                justify-content: space-between;
                margin-top: 10px;
                width: 130px;
                height: 12px;
                line-height: 12px;
                .btn {
                  cursor: pointer;
                  font-size: 12px;
                  color: $--color-primary;
                }
              }
            }
          }
          .upload-tips {
            color: #bbb;
            span {
              font-size: 12px;
              color: $--color-primary;
            }
          }
        }
        // margin-bottom: 12px;
        ::v-deep .el-upload-dragger {
          border: 0;
        }
        ::v-deep .img-list .el-upload {
          border-radius: 0px;
          width: 350px;
          height: 150px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        ::v-deep .el-upload--picture-card {
          margin-right: 40px;
          width: 350px;
          height: 150px;
          border-radius: 0;
          border-color: #ddd;
        }
        .img-list .el-upload:hover {
          border-color: #409eff;
        }

        .avatar {
          @include flex(row, center);
          width: 178px;
          height: 400px;
          img {
            width: 50%;
            height: 100%;
          }
          .img-info {
            width: 100%;
            height: 100%;
          }
        }
      }

      .tips {
        margin-top: 12px;
        font-size: 12px;
        color: #888;
      }
    }
  }
}
</style>
